import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { FaltaGlobalFilters, FaltaGlobalListItem } from './types';

/**
 * Listagem global de Faltas — `ApiEmployeeFaltaListAll`, publicado pela Genie
 * (card [YuqtX0mn]/ATD-0053, GATE_OK 2026-08-23; smoke verde). BFF roteia a
 * rota estática `GET /employees/faltas` em `registerEmployeeFaltasGlobal`.
 */
const BASE = '/v1/employees/faltas';

export const faltasGlobalApi = {
  async list(
    query: DataTableQuery,
    filters?: FaltaGlobalFilters,
  ): Promise<ListEnvelope<FaltaGlobalListItem>> {
    const { data } = await api.get<{
      data: Omit<FaltaGlobalListItem, 'id'>[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, {
      params: toGenexusParams(query, {
        colaboradorCodigo: filters?.colaboradorCodigo ?? undefined,
      }),
    });
    const normalized = normalizeListEnvelope(data);
    return {
      ...normalized,
      data: normalized.data.map((r) => ({ ...r, id: `${r.employeeId}-${r.dataFalta}` })),
    };
  },
};
